export const SET_CLAIM = 'claim/SET_CLAIM';
export const RESET_CLAIM = 'claim/RESET_CLAIM';

export interface SetClaim {
  type: typeof SET_CLAIM;
  payload: object;
}


export interface ResetClaim {
  type: typeof RESET_CLAIM;
}

// --- Create Union Type
export type ActionsTypes =
  | SetClaim
  | ResetClaim;
